/* My Acre buy box v2 (21 Oct 2026, Claude; design approved by Hayden 21 Oct).
   Product page only (loaded from snippets/product.liquid). Phone photo count "1 / N"
   on the main gallery photo. Reads the slider's own selected cell, changes nothing else. */
(function () {
  function init() {
    var viewer = document.querySelector('.product--outer [data-gallery-viewer]');
    if (!viewer || viewer.querySelector('.ma-gal-count')) return;
    var figs = viewer.querySelectorAll('[data-gallery-figure]');
    if (figs.length < 2) return;
    var badge = document.createElement('span');
    badge.className = 'ma-gal-count';
    badge.setAttribute('aria-hidden', 'true');
    viewer.appendChild(badge);
    function update() {
      var idx = 0;
      for (var i = 0; i < figs.length; i++) { if (figs[i].classList.contains('is-selected')) { idx = i; break; } }
      badge.textContent = (idx + 1) + ' / ' + figs.length;
    }
    update();
    var mo = new MutationObserver(update);
    for (var j = 0; j < figs.length; j++) mo.observe(figs[j], { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'complete') init(); else window.addEventListener('load', init);
})();



/* Swatch close-up removed 21 Oct 2026 (Hayden): it added nothing, and a zoomed screen colour risks not matching the real finish. */

/* Call us beside Add to Cart. A phone dials straight away. A laptop without a calling app
   does nothing with a phone link, so there the click also copies the number and says so. */
(function () {
  function init() {
    var a = document.querySelector('.product--outer .ma-atc-call');
    if (!a) return;
    var done = document.createElement('span');
    done.className = 'ma-call__copied';
    done.textContent = 'Number copied: 1300 515 620';
    a.appendChild(done);
    a.addEventListener('click', function () {
      if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText('1300 515 620');
      } catch (e) {}
      a.classList.add('is-copied');
      setTimeout(function () { a.classList.remove('is-copied'); }, 2600);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Stand and option cards (Giotto): show what each choice adds to the price, worked out from
   the product's own variant prices for the colour picked now. Read only; selection is untouched. */
(function () {
  function money(n) { return '$' + Math.round(n).toLocaleString('en-AU'); }
  function init() {
    var sel = document.querySelector('.product--outer form[action*="/cart/add"] select[name="id"]');
    var fields = document.querySelectorAll('.product--outer .ma-option--cards');
    if (!sel || !fields.length) return;
    var variants = [];
    for (var i = 0; i < sel.options.length; i++) {
      var t = sel.options[i].textContent.replace(/\s+/g, ' ').trim();
      var m = t.match(/^(.*) - \$([\d,]+(?:\.\d+)?)$/);
      if (!m) continue;
      variants.push({ opts: m[1].split(' / '), price: parseFloat(m[2].replace(/,/g, '')) });
    }
    if (!variants.length) return;
    function current() {
      var cur = [];
      document.querySelectorAll('.product--outer form[action*="/cart/add"] [data-product-option]:checked').forEach(function (inp) { cur[+inp.getAttribute('data-product-option')] = inp.value; });
      return cur;
    }
    function priceFor(idx, val, cur) {
      for (var k = 0; k < variants.length; k++) {
        var o = variants[k].opts, ok = o[idx] === val;
        for (var n = 0; ok && n < o.length; n++) if (n !== idx && cur[n] !== undefined && o[n] !== cur[n]) ok = false;
        if (ok) return variants[k].price;
      }
      return null;
    }
    function paint() {
      var cur = current();
      fields.forEach(function (fs) {
        var idx = +(fs.getAttribute('data-ma-cards-index') || 0);
        var cards = fs.querySelectorAll('.ma-card');
        var prices = [], low = Infinity;
        cards.forEach(function (card, i) { var p = priceFor(idx, card.getAttribute('data-ma-card-value'), cur); prices[i] = p; if (p !== null && p < low) low = p; });
        var allSame = prices.every(function (v) { return v === null || v === low; });
        cards.forEach(function (card, i) {
          var txt = card.querySelector('.ma-card__txt'); if (!txt) return;
          var el = txt.querySelector('.ma-card__price');
          if (!el) { el = document.createElement('span'); el.className = 'ma-card__price'; txt.appendChild(el); }
          var p = prices[i];
          if (p === null || low === Infinity) { el.textContent = ''; return; }
          var diff = p - low;
          el.textContent = diff > 0 ? 'Add ' + money(diff) : 'Base price';
          el.classList.toggle('is-base', diff <= 0);
          el.classList.toggle('is-same', allSame);
        });
      });
    }
    paint();
    document.addEventListener('change', function () { setTimeout(paint, 60); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Add-ons and Add to Cart work one way only (Hayden, 21 Oct 2026: "needs to all work the exact same").
   - A tick, the row, the add-on's own pop-up: each only PICKS the add-on (aria-pressed + .is-picked).
     Nothing reaches the cart and no confirmation shows. The old .is-added class is never set, so the
     theme's bottom banner (assets/ma-atc-banner.js watches that class) never fires.
   - Add to Cart, from the main button or the sticky bar, is the only thing that adds. When the main
     item's cart add comes back OK, the picked add-ons go in with ONE follow-up call (never at the same
     time: memory feedback-cart-correctness). The single confirmation (the header's toast) then names
     everything that went in, and the picks clear so a second Add to Cart never doubles them. */
(function () {
  var MARK = 'X-MA-Addons';
  function rows() { return document.querySelectorAll('.product--outer [data-ma-ob-add]'); }
  function setPicked(btn, on) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.classList.toggle('is-picked', on);
    btn.classList.remove('is-added');
    var name = (btn.closest('.ma-ob__row') && btn.closest('.ma-ob__row').querySelector('.ma-ob__name') || {}).textContent || '';
    btn.setAttribute('aria-label', (on ? 'Remove ' : 'Add ') + name.trim() + (on ? ' from my order' : ' to my order'));
  }
  rows().forEach(function (b) { setPicked(b, false); b.textContent = ''; });
  /* a small "Details" link under each add-on name opens its detail pop-up; it never adds or ticks */
  document.querySelectorAll('.product--outer .ma-ob__row').forEach(function (row) {
    var meta = row.querySelector('.ma-ob__meta');
    if (!meta || meta.querySelector('.ma-ob__details') || !document.querySelector('[data-ma-ob-modal="' + row.getAttribute('data-ma-ob-open') + '"]')) return;
    var d = document.createElement('button');
    d.type = 'button'; d.className = 'ma-ob__details'; d.textContent = 'Details';
    d.setAttribute('aria-label', 'Details about ' + ((row.querySelector('.ma-ob__name') || {}).textContent || '').trim());
    meta.appendChild(d);
  });
  function picked() {
    var out = [];
    rows().forEach(function (b) { if (b.getAttribute('aria-pressed') === 'true') { var id = parseInt(b.getAttribute('data-id'), 10); if (id) out.push({ id: id, name: ((b.closest('.ma-ob__row') || {}).querySelector ? (b.closest('.ma-ob__row').querySelector('.ma-ob__name') || {}).textContent || '' : '').trim() }); } });
    return out;
  }
  function closeModals() {
    document.querySelectorAll('[data-ma-ob-modal]:not([hidden])').forEach(function (m) { m.setAttribute('hidden', ''); });
    document.documentElement.classList.remove('ma-ob-modal-lock');
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null; if (!t) return;
    /* the pop-up lives on <body> while open (so it sits above the header); close it from here */
    if (t.closest('[data-ma-ob-modal] [data-ma-ob-close]')) { e.preventDefault(); e.stopPropagation(); closeModals(); return; }
    var details = t.closest('.product--outer .ma-ob__details');
    if (details) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      closeModals();
      var m = document.querySelector('[data-ma-ob-modal="' + details.closest('.ma-ob__row').getAttribute('data-ma-ob-open') + '"]');
      if (m) { if (m.parentElement !== document.body) document.body.appendChild(m); m.removeAttribute('hidden'); document.documentElement.classList.add('ma-ob-modal-lock'); var c = m.querySelector('[data-ma-ob-close]'); if (c && c.focus) c.focus(); }
      return;
    }
    var tick = t.closest('.product--outer [data-ma-ob-add]');
    /* the whole row behaves like its tick box: one tap, one behaviour, wherever it lands */
    var row = !tick && t.closest('.product--outer .ma-ob__row');
    if (row) tick = row.querySelector('[data-ma-ob-add]');
    var modalAdd = t.closest('[data-ma-ob-modal-add]');
    if (!tick && !modalAdd) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    if (tick) { setPicked(tick, tick.getAttribute('aria-pressed') !== 'true'); return; }
    var target = document.querySelector('.product--outer [data-ma-ob-add][data-id="' + modalAdd.getAttribute('data-target-id') + '"]');
    if (target) setPicked(target, true);
    closeModals();
  }, true);
  document.querySelectorAll('[data-ma-ob-modal-add]').forEach(function (b) { b.textContent = 'Add to my order'; });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModals(); });

  var busy = false, mainTitle = '';
  function setToastLabel(text) {
    var el = document.querySelector('[data-ma-cart-notification-product]');
    if (el && text) el.textContent = text;
  }
  function addPicked() {
    var list = picked();
    if (!list.length || busy) return;
    busy = true;
    var send = window.__maOrigFetch || window.fetch;
    send('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-MA-Addons': '1' }, body: JSON.stringify({ items: list.map(function (x) { return { id: x.id, quantity: 1 }; }) }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.items) {
          rows().forEach(function (b) { setPicked(b, false); });
          var label = mainTitle + ' with ' + list.map(function (x) { return x.name; }).join(', ');
          setToastLabel(label); setTimeout(function () { setToastLabel(label); }, 250); setTimeout(function () { setToastLabel(label); }, 700);
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }
  function isMainAdd(url, headers) {
    if (!/\/cart\/add/.test(String(url || ''))) return false;
    if (headers && ((headers.get && headers.get(MARK)) || headers[MARK])) return false;
    return true;
  }
  function onMain() {
    mainTitle = ((document.querySelector('.product--outer h1.product-title') || {}).textContent || '').trim();
    /* with nothing picked, the one confirmation still names the product (a mount upgrade would otherwise read "2 items added") */
    if (!picked().length) { setTimeout(function () { setToastLabel(mainTitle); }, 250); setTimeout(function () { setToastLabel(mainTitle); }, 700); }
    setTimeout(addPicked, 0);
  }
  if (window.fetch && !window.__maOrigFetch) {
    window.__maOrigFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var main = isMainAdd(url, init && init.headers);
      var p = window.__maOrigFetch.apply(this, arguments);
      if (main) p.then(function (r) { if (r && r.ok) onMain(); }).catch(function () {});
      return p;
    };
  }
  var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this.__maUrl = url; return XO.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this;
    if (isMainAdd(x.__maUrl)) x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) onMain(); });
    return XS.apply(this, arguments);
  };
})();

/* Configuration cards: "Base price" or "Add $X" (worked out from the prices the picker prints),
   matching the mount and stand cards. Re-applied whenever the picker repaints. */
(function () {
  function money(n) { return '$' + Math.round(n).toLocaleString('en-AU'); }
  function relabel(root) {
    var els = root.querySelectorAll('.ma-cfg__price');
    if (!els.length) return;
    var vals = [];
    els.forEach(function (el, i) {
      var txt = (el.textContent || '').trim();
      var raw = txt.charAt(0) === '$' ? txt : el.getAttribute('data-ma-price');
      var n = parseFloat(String(raw || '').replace(/[^0-9.]/g, ''));
      if (txt.charAt(0) === '$' && !isNaN(n)) el.setAttribute('data-ma-price', String(n));
      vals[i] = isNaN(n) ? null : n;
    });
    var low = Math.min.apply(null, vals.filter(function (v) { return v !== null; }));
    if (!isFinite(low)) return;
    var same = vals.every(function (v) { return v === null || v === low; });
    els.forEach(function (el, i) {
      if (vals[i] === null) return;
      el.classList.toggle('is-same', same);
      var d = vals[i] - low, t = d > 0 ? 'Add ' + money(d) : 'Base price';
      if (el.textContent !== t) el.textContent = t;
      el.classList.toggle('is-base', d <= 0);
    });
  }
  function init() {
    document.querySelectorAll('.product--outer .ma-cfg--tiles').forEach(function (root) {
      relabel(root);
      new MutationObserver(function () { relabel(root); }).observe(root, { childList: true, subtree: true, characterData: true });
    });
  }
  if (document.readyState === 'complete') init(); else window.addEventListener('load', init);
})();


/* One confirmation on mount-picker products too (independent audit, 22 Oct): assets/ma-mount-picker.js opens its
   own "Added to your cart" card beside the header toast. That card stays hidden; it only shows if the add FAILED
   ("Not added"), because then it carries the reason and the phone number. */
(function () {
  function check(card) {
    var t = card.querySelector('.ma-atc__title');
    if (t && /not added/i.test(t.textContent || '')) card.classList.add('ma-atc--show');
  }
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) { if (n.nodeType === 1 && n.classList.contains('ma-atc')) { check(n); new MutationObserver(function () { check(n); }).observe(n, { childList: true, subtree: true, characterData: true }); } });
    });
  }).observe(document.body, { childList: true });
})();
